import { useDasBalanceContext } from '@did/das-app-context'
import { CKB } from '@did/constants/chain'
import { CYCLE_CALL_FUNCTION_TIME, FIAT_DECIMAL_PLACES } from '@did/constants'
import { UseAvailableBalance } from '@did/das-balance-types'
import { fromSatoshi } from '@did/tools'
import Decimal from 'decimal.js'
import { useEffect, useMemo, useState } from 'react'
import { IToken } from '@did/types'

export const useAvailableBalance: UseAvailableBalance = () => {
  const { services, connectedAccount } = useDasBalanceContext()
  const [availableBalance, setAvailableBalance] = useState('0')
  const [transitBalance, setTransitBalance] = useState('0')
  const [tokens, setTokens] = useState<IToken[]>([])

  const fetchToken = async () => {
    const tokensRes = await services.common.tokens()
    setTokens(tokensRes.token_list)
  }

  const fetchBalance = async () => {
    if (
      !connectedAccount ||
      !connectedAccount?.chain?.coinType ||
      !connectedAccount?.address
    )
      return
    const balanceInfo = await services.account.balanceInfo({
      key_info: {
        coin_type: connectedAccount.chain?.coinType,
        key: connectedAccount.address
      },
      transfer_address: ''
    })
    setTransitBalance(fromSatoshi(balanceInfo.transfer_address_amount))
    setAvailableBalance(fromSatoshi(balanceInfo.das_lock_amount))
  }

  useEffect(() => {
    fetchToken()
  }, [])

  useEffect(() => {
    if (!connectedAccount?.address) {
      return
    }
    fetchBalance()

    const timerId = setInterval(() => {
      fetchBalance()
    }, CYCLE_CALL_FUNCTION_TIME * 3)
    return () => {
      clearInterval(timerId)
    }
  }, [connectedAccount])

  const balanceUSD = useMemo(() => {
    const res = tokens.find((token: IToken) => {
      return CKB.tokenId === token.token_id
    })

    if (res && res.price) {
      return new Decimal(availableBalance)
        .times(res.price)
        .toFixed(FIAT_DECIMAL_PLACES)
    } else {
      return '0'
    }
  }, [tokens, availableBalance])

  return {
    availableBalance,
    balanceUSD,
    transitBalance,
    fetchBalance
  }
}
